"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = Box;
exports.base = void 0;
var _polished = require("polished");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Styled components
// -------------------------------------------------------------------------------------------------

// Make sure that we use styled-component's own typing for the `as` prop.

/**
 * Base styles for the box component that other low-level components (i.e. `Row` and `Stack`) may use. **You probably
 * should not be using this.**
 */
const base = (0, _styledComponents.css)`
  ${({
  backgroundColor,
  theme
}) => backgroundColor && (0, _styledComponents.css)`
      background-color: ${theme.colors[backgroundColor]};
    `};

  ${({
  grow
}) => grow === true && (0, _styledComponents.css)`
      flex-grow: 1;
    `};

  ${({
  padding,
  theme
}) => typeof padding !== 'undefined' && (0, _styledComponents.css)`
      padding: ${(0, _polished.rem)(theme.spacing[padding])};
    `};

  ${({
  paddingHorizontal,
  theme
}) => typeof paddingHorizontal !== 'undefined' && (0, _styledComponents.css)`
      padding-left: ${(0, _polished.rem)(theme.spacing[paddingHorizontal])};
      padding-right: ${(0, _polished.rem)(theme.spacing[paddingHorizontal])};
    `};

  ${({
  paddingVertical,
  theme
}) => typeof paddingVertical !== 'undefined' && (0, _styledComponents.css)`
      padding-bottom: ${(0, _polished.rem)(theme.spacing[paddingVertical])};
      padding-top: ${(0, _polished.rem)(theme.spacing[paddingVertical])};
    `};

  ${({
  paddingBottom,
  theme
}) => typeof paddingBottom !== 'undefined' && (0, _styledComponents.css)`
      padding-bottom: ${(0, _polished.rem)(theme.spacing[paddingBottom])};
    `};

  ${({
  paddingLeft,
  theme
}) => typeof paddingLeft !== 'undefined' && (0, _styledComponents.css)`
      padding-left: ${(0, _polished.rem)(theme.spacing[paddingLeft])};
    `};

  ${({
  paddingRight,
  theme
}) => typeof paddingRight !== 'undefined' && (0, _styledComponents.css)`
      padding-right: ${(0, _polished.rem)(theme.spacing[paddingRight])};
    `};

  ${({
  paddingTop,
  theme
}) => typeof paddingTop !== 'undefined' && (0, _styledComponents.css)`
      padding-top: ${(0, _polished.rem)(theme.spacing[paddingTop])};
    `};

  ${p => p.absoluteFill && (0, _styledComponents.css)`
      bottom: 0;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
    `};
`;
exports.base = base;
const Base = _styledComponents.default.div`
  ${base};
`;

//
// Main component
// -------------------------------------------------------------------------------------------------

/**
 * A list of element names that we don't want to allow the `Box` component to be able to be used as.
 */
/**
 * A low-level layout component whose job it is to render an individual element on the screen. In terms of layout,
 * `Box` most notably provides a set of padding options which can be used to create container elements with
 * internal spacing.
 *
 * @beta
 */
function Box({
  absoluteFill,
  as,
  backgroundColor,
  children,
  testId,
  ...rest
}) {
  const {
    padding,
    paddingBottom,
    paddingHorizontal,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingVertical
  } = rest;

  // Since a `className` can techincally still be passed in, but we don't want people doing that, we overload the type
  // here to extract the `className` while still keeping "hidden" to users of the component. The reason we still want
  // a `className` to be able to be passed in is so that some components can extend the `Box` component's styles (i.e.
  // the Flex component).
  const {
    className
  } = rest;

  // Display an error message in the console if a developer tries to pass their only CSS class into the component.
  // The `className` prop is internally used so that the Box component can be extended.
  // eslint-disable-next-line no-console
  console.assert(typeof className !== 'string' || className.startsWith('sc-'), '💣 %cThe className prop of the Box component is not for setting arbitary classes.', 'font-weight: bold');
  return /*#__PURE__*/_react.default.createElement(Base, {
    absoluteFill: absoluteFill,
    as: as,
    backgroundColor: backgroundColor,
    "data-testid": testId,
    className: className,
    padding: padding,
    paddingBottom: paddingBottom,
    paddingHorizontal: paddingHorizontal,
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    paddingTop: paddingTop,
    paddingVertical: paddingVertical
  }, children);
}